/* eslint-disable max-len */
const PRIVATE_HEALTH_INSURANCE_BROCHURE_LINK = 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/pmi/may-update/saga-health-insurance-quote-brochure.pdf?cd=view';
const PRIVATE_HEALTH_INSURANCE_BROCHURE_LINK_MAY25 = 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/pmi/may-update/saga-health-insurance-quote-brochure-may-25.pdf?cd=view';
const IMPORTANT_INFO_LINK = 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/pmi/may-update/saga-health-insurance-important-information.pdf?cd=view';
const IMPORTANT_INFO_LINK_MAY25 = 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/pmi/may-update/saga-health-insurance-important-information-may-25.pdf?cd=view';
const PRIVATE_HEALTH_INSURANCE_POLICY_DETAILS_LINK = 'https://www.saga.co.uk/insurance/health-insurance/policy-details';
const WHY_CHOOSE_SAGA_LINK = 'https://www.saga.co.uk/insurance/health-insurance/get-quote/info';
const HOSPITAL_LIST_PDF_MAY = 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/pmi/may-update/saga-health-insurance-hospital-list.pdf?cd=view';
const SAGA_HEALTHPLAN_LINK = 'https://www.saga.co.uk/health-insurance/compare-healthplans';
const POLICY_BOOKS_LINK = 'https://www.saga.co.uk/health-insurance/existing-customers#anchor_Policybooks';
const ABI_GUIDE_LINK = 'https://www.abi.org.uk/globalassets/files/publications/public/health/2017/08/abi_bro3887_pmi_health_guide_v4.pdf';
const FAQ_QUESTIONS_KEYS = ['coverCost', 'notCovered', 'preExisting', 'noClaimDiscount', 'cancer'];
const HOSPITAL_LIST_PDF_MAY_25 = 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/pmi/may-update/saga-health-insurance-hospital-list-may-25.pdf?cd=view';

const HOSPITAL_OPTIONS_CODE = {
    GUIDED_CARE: 'fixed_fast_track',
    COUNTRYWIDE_HOSPITAL_LIST: 'countrywide_hospital_list',
    LONDON_UPGRADE: 'london_upgrade'
};

const HOSPITAL_OPTION_NAMES = {
    fixed_fast_track: 'Guided Care',
    countrywide_hospital_list: 'Countrywide',
    london_upgrade: 'Additional London hospitals'
};

const HOSPITAL_MAP_FILTERS = {
    IN_PATIENT: 'InPatient',
    SCANNING: 'Scanning'
};

const HOSPITAL_MAP_PINS = {
    LONDON_UPGRADE: 'red',
    COUNTRYWIDE: 'default'
};

const HOSPITAL_MAP_PROPS = {
    ZOOM: {
        LEVEL_6: 6,
        LEVEL_10: 10,
        LEVEL_13: 13
    },
    DEFAULT_CENTER: {
        lat: 54.3183993,
        lng: -3.6400244
    }
};

const NHS_CASH_BENEFIT_LEVEL_PER_NIGHT = {
    SUPER: '150',
    SECURE: '100',
    SAVER_PLUS: '100'
};

const NHS_CASH_BENEFIT_LEVEL_PER_YEAR = {
    SUPER: '3,000',
    SECURE: '2,000',
    SAVER_PLUS: '2,000'
};

const AMOUNT_OP_CONSULTATIONS_LEVEL = {
    SUPER: '3,000',
    SECURE: '2,000',
    SAVER_PLUS: '1,000'
};

const AMOUNT_OP_YEAR_CONSULTATIONS_LEVEL = {
    SUPER: '2,500',
    SECURE: '2,000',
    SAVER_PLUS: '1,500'
};

const COVER_LEVEL_CODES = {
    SUPER: 'shp_super',
    SECURE: 'shp_secure',
    SAVER_PLUS: 'shp_saver_plus'
};

const MONTHLY_PRICE_NAMES = {
    shp_saver_plus: 'saverPlusMonthlyPrice',
    shp_secure: 'secureMonthlyPrice',
    shp_super: 'superMonthlyPrice'
};

const QUARTERLY_PRICE_NAMES = {
    shp_saver_plus: 'saverPlusQuarterlyPrice',
    shp_secure: 'secureQuarterlyPrice',
    shp_super: 'superQuarterlyPrice'
};

const RELATIONSHIP_CODES = {
    CHILD: 'child',
    CUSTOMER: 'customer'
};

const SMI_COOKIES = {
    VOS_COOKIE: 'VoSSwitcher',
    VOS_COOKIE_EXPIRATION_TIME: 31,
    HEALTH_SID_COOKIE: 'healthSessionId',
    HEALTH_SID_COOKIE_SID_LENGTH: 24
};

const SG_SMI_ERROR_REASONS = {
    CHANNEL_ISLANDS: 9128
};

const SMI_ADDON_ACRONYMS = {
    EXTENDED_CANCER_COVER: 'ECC',
    NO_CLAIM_DISCOUNT_PROTECTION: 'NCM',
    HEALTH_CASH_BENEFITS_COVER: 'HCB',
    HIGH_BLOOD_PRESSURE_ADDON: 'HBP'
};

const SMI_ADDON_TRACKING_NAMES = {
    EXTENDED_CANCER_COVER: 'extendedCancerCover',
    NO_CLAIM_DISCOUNT_PROTECTION: 'noClaimDiscountProtection',
    HEALTH_CASH_BENEFITS_COVER: 'healthCashBenefitsCover',
    HIGH_BLOOD_PRESSURE_ADDON: 'hypertensionAddon'
};

const SMI_ADDON_REMOVED_NAMES = {
    EXTENDED_CANCER_COVER: 'extendedCancerCoverRemoved',
    NO_CLAIM_DISCOUNT_PROTECTION: 'noClaimDiscountProtectionRemoved',
    HEALTH_CASH_BENEFITS_COVER: 'healthCashBenefitsCoverRemoved',
    HIGH_BLOOD_PRESSURE_ADDON: 'hypertensionAddonRemoved'
};

const SMI_ADDON_REVERSE_NAMES = {
    EXTENDED_CANCER_COVER: 'EXTENDED_CANCER_COVER',
    NO_CLAIM_DISCOUNT_PROTECTION: 'NO_CLAIM_DISCOUNT_PROTECTION',
    HEALTH_CASH_BENEFITS_COVER: 'HEALTH_CASH_BENEFITS_COVER',
    HIGH_BLOOD_PRESSURE_ADDON: 'HIGH_BLOOD_PRESSURE_ADDON'
};

const PRODUCT_TYPE = {
    PRODUCT: 'Product',
    SUPER: 'Super',
    SECURE: 'Secure',
    SAVER_PLUS: 'SaverPlus'
};

const FOUR_WEEK_WAIT_ADDON_LEVEL = {
    SUPER_4: 'Super4',
    SECURE_4: 'Secure4',
    SAVER_PLUS_4: 'SaverPlus4'
};

const PRODUCT_NAMES = {
    shp_super: 'Super',
    shp_secure: 'Secure',
    shp_saver_plus: 'Saver Plus'
};

const IPID_PAGE = {
    Title: 'Title',
    ProductTitle: 'ProductTitle',
    InsuranceTypeDesc: 'InsuranceTypeDesc'
};

const NUMBER_OF_INSTALMENTS = {
    ELEVEN: 11,
    TWELVE: 12
};

const AGGREGATOR_CAMPAIGN_CODES = ['CTMPMI', 'IT2106', 'IT2107'];

const SMI = 'smi';

const SAGA_PRIVATE_HEALTH = 'Saga Private Health';

const ADOBE_VALUES = {
    QUOTE_SELECT_PLAN: 'quoteSelectPlan',
    FOUR_WEEK_WAIT: 'fourWeekWait',
    YES: 'Yes',
    NO: 'No',
    MORE_INFORMATION: 'MoreInformation',
    LESS_INFORMATION: 'LessInformation',
    EXTENDED_CANCER_COVER: 'extendedCancerCover',
    QUOTE_TAILOR_EXTENDED_CANCER: 'quoteTailorExtendCancer',
    CANCEL: 'Cancel',
    OK: 'OK',
    HEALTH_CASH_BENEFITS: 'healthCashBenefits',
    QUOTE_TAILOR_HEALTH_CASH_BENEFITS: 'quoteTailorHealthCashBenefits',
    NO_CLAIM_DISCOUNT_PROTECTION: 'noClaimDiscountProtection',
    PRIVATE_HEALTH_INSURANCE_BROCHURE: 'privateHealthInsuranceBrochure',
    QUOTE_PREMIUM: 'quotePremium',
    ANNUAL_SELECT: 'AnnualSelect',
    MONTHLY_SELECT: 'MonthlySelect',
    QUARTERLY_SELECT: 'QuarterlySelect',
    EDIT_COVER_START_DATE: 'editCoverStartDate',
    MORE_DETAIL: 'MoreDetail',
    LESS_DETAIL: 'LessDetail',
    COUNTRYWIDE_HOSPITAL_SELECTED: 'countrywideHospitalSelected',
    LONDON_UPGRADE_SELECTED: 'londonUpgradeSelected',
    GUIDED_CARE_SELECTED: 'guidedCareSelected',
    ENLARGE_MAP: 'enlargeMap',
    VIEW_HOSPITAL_LIST_LINK: 'viewHospitalListLink',
    QUOTE_PEOPLE: 'quotePeople',
    PARTNER: 'Partner',
    DEPENDANT: 'Dependant',
    ADD: 'Add',
    SAVE: 'Save',
    REMOVE: 'Remove',
    EDIT: 'Edit',
    EXCESS: 'excess'
};

const DIALLER_JOURNEY_INDEX = {
    QUOTE_PAGE_INIT: '0',
    COVER_LEVEL_SELECT: '1',
    COVER_ADJUST: '2',
    REVIEW_PAGE_INIT: '3',
    PAYMENT_PAGE_INIT: '4',
    CONFIRMATION_PAGE_INIT: '5'
};

export default {
    PRIVATE_HEALTH_INSURANCE_BROCHURE_LINK,
    PRIVATE_HEALTH_INSURANCE_BROCHURE_LINK_MAY25,
    FAQ_QUESTIONS_KEYS,
    PREVIOUS_INSURER_NONE_OPTION: 'none',
    IMPORTANT_INFO_LINK,
    IMPORTANT_INFO_LINK_MAY25,
    SAGA_HEALTHPLAN_LINK,
    POLICY_BOOKS_LINK,
    ABI_GUIDE_LINK,
    SG_SMI_ERROR_REASONS,
    PRIVATE_HEALTH_INSURANCE_POLICY_DETAILS_LINK,
    WHY_CHOOSE_SAGA_LINK,
    HOSPITAL_OPTIONS_CODE,
    HOSPITAL_LIST_PDF_MAY,
    HOSPITAL_MAP_FILTERS,
    HOSPITAL_MAP_PINS,
    HOSPITAL_MAP_PROPS,
    RELATIONSHIP_CODES,
    COVER_LEVEL_CODES,
    PRODUCT_TYPE,
    PRODUCT_NAMES,
    FOUR_WEEK_WAIT_ADDON_LEVEL,
    IPID_PAGE,
    SMI,
    AGGREGATOR_CAMPAIGN_CODES,
    NHS_CASH_BENEFIT_LEVEL_PER_NIGHT,
    NHS_CASH_BENEFIT_LEVEL_PER_YEAR,
    SMI_COOKIES,
    HOSPITAL_OPTION_NAMES,
    MONTHLY_PRICE_NAMES,
    QUARTERLY_PRICE_NAMES,
    SMI_ADDON_ACRONYMS,
    SMI_ADDON_TRACKING_NAMES,
    SMI_ADDON_REMOVED_NAMES,
    SMI_ADDON_REVERSE_NAMES,
    AMOUNT_OP_CONSULTATIONS_LEVEL,
    AMOUNT_OP_YEAR_CONSULTATIONS_LEVEL,
    NUMBER_OF_INSTALMENTS,
    SAGA_PRIVATE_HEALTH,
    ADOBE_VALUES,
    DIALLER_JOURNEY_INDEX,
    HOSPITAL_LIST_PDF_MAY_25
};
